import { render, staticRenderFns } from "./MyMatches.vue?vue&type=template&id=18bff26c&scoped=true&"
import script from "./MyMatches.vue?vue&type=script&lang=js&"
export * from "./MyMatches.vue?vue&type=script&lang=js&"
import style0 from "./MyMatches.vue?vue&type=style&index=0&id=18bff26c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bff26c",
  null
  
)

component.options.__file = "MyMatches.vue"
export default component.exports